const getters = {
    GET_MESSAGE: (state) => state.message,
    GET_MESSAGE_TYPE: (state) => state.isError,
    GET_WARNING: (state) => state.warning,
}

export default getters
